module.exports = __webpack_public_path__ + "img/lens-150-plus-07.8e59690b.png";